/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Un partenaire sous mesure de protection juridique *ou* sous la protection de
 * l'OFPRA est accompagné de représentants légaux : les libellés « parents » de
 * l'assistant (titre d'étape et titre de section) parlent alors de
 * « représentants légaux ».
 */
const hasRepresentantsLegaux = (partenaire?: {
  protectionJuridique?: boolean | null;
  protectionOfpra?: boolean | null;
}) =>
  partenaire?.protectionJuridique === true ||
  partenaire?.protectionOfpra === true;

export default hasRepresentantsLegaux;
